import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class SnackBarService {

    private readonly SNACK_BAR_DURATION: number = 4; // seconds
    private readonly CLOSE_TEXT_KEY: string = 'close';

    constructor(private snackBar: MatSnackBar, private translate: TranslateService) { }

    showErrorMessage(messageKey: string, position: MatSnackBarVerticalPosition = 'bottom', duration: number = this.SNACK_BAR_DURATION):
        Observable<MatSnackBarRef<any>> {
        return this.showSnackBar(messageKey, 'snackbar-error', position, duration);
    }

    showInfoMessage(messageKey: string, position: MatSnackBarVerticalPosition = 'bottom', duration: number = this.SNACK_BAR_DURATION):
        Observable<MatSnackBarRef<any>> {
        return this.showSnackBar(messageKey, 'snackbar-info', position, duration);
    }

    private showSnackBar(messageKey: string, snackBarClass: string, position: MatSnackBarVerticalPosition, duration: number): Observable<MatSnackBarRef<any>> {
        return this.translate.get([this.CLOSE_TEXT_KEY, messageKey])
            .pipe(map(messages => {
                const snackBarRef = this.snackBar.open(messages[messageKey], messages[this.CLOSE_TEXT_KEY], {
                    duration: duration * 1000,
                    verticalPosition: position,
                    panelClass: snackBarClass
                });
                snackBarRef.onAction().subscribe(() => {
                    snackBarRef.dismiss();
                });
                return snackBarRef;
            }));
    }

}

